import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { ReceiveResult } from './receive-result.action';

export function receiveResultReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<
        ActionType.COACHING__CA__RECEIVE_RESULT,
        ReceiveResult
    >,
): CaAnalysisDialogState {
    return {
        ...state,
        result: action.payload.result,
    };
}
